export default __webpack_public_path__ + "static/media/Me typically at the party.e0c72578.mp4";